import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import ReceivementCard from '../../../../components/ReceivementCard'

import { useReceivement } from '../../../../hooks/useReceivement'

import * as S from './NewReceivementDetails.styles'
import { ReceivementOverviewFilters } from '../../components/ReceivementOverviewFilters'
import { useSelector } from 'react-redux'
import * as selectors from '../../ReceivementSelectors'
import { ReceivementDetailOverviewTable } from '../../components/ReceivementTables'
import { ReceivementHeader } from '../../components/ReceivementHeader'
import { ReceivementInfo } from '../../components/ReceivementInfo'
import { SupplierInfo } from '../../components/SupplierInfo/SupplierInfo'
import { InfoReturnOptions } from '../../ReceivementTypes'

const NewReceivementDetails = () => {
  const { receivementId } = useParams<{ receivementId?: string }>()
  const { supervisorBadge } = useReceivement({ validateSupervisor: true })
  const history = useHistory()
  const overview = useSelector(selectors.selectOverview)
  const [invoiceReturnOptions, setInvoiceReturnOptions] = useState<InfoReturnOptions>()

  const headerButton = React.useMemo(() => (
    <S.Button
      onClick={() => {
        history.push({
          pathname: '/receivement/list',
          state: {
            loadPreviousFilters: true,
          },
        })
      }}
    >
      Voltar
    </S.Button>
  ),
  [history])

  useEffect(() => {
    if (overview) {
      const {
        allowBreakUnitOnInvoiceReturn,
        allowInvoiceReturn,
        allowPartialReturn,
        allowProductExchange,
      } = overview

      setInvoiceReturnOptions({
        allowBreakUnitOnInvoiceReturn, allowInvoiceReturn, allowPartialReturn, allowProductExchange,
      })
    }
  }, [overview])

  return (
    <S.Container>
      <ReceivementHeader
        title={(
          <S.SubTitle>
            Resumo do Recebimento{' '}
            <S.SubTitleExtension>- ARs e Lotes</S.SubTitleExtension>
          </S.SubTitle>
        )}
        headerButton={headerButton}
      />
      <S.ContainerInfo>
        <ReceivementInfo
          operator={overview?.operator}
          supervisor={overview?.supervisor}
          dock={overview?.dock}
          supplier={overview?.supplier}
          duration={overview?.duration}
          startDate={overview?.receivementStartDate}
          receivementId={receivementId}
        />
        {
          invoiceReturnOptions && <SupplierInfo info={invoiceReturnOptions}/>
        }
      </S.ContainerInfo>
      <ReceivementOverviewFilters badge={supervisorBadge}/>
      {overview?.products?.map((product, index) => (
        <ReceivementCard
          key={`${product.productCode}-${index}`}
          product={product}
          BatchesTable={ReceivementDetailOverviewTable}
        />
      ))}
    </S.Container>
  )
}

export default NewReceivementDetails
